// swiperInit.js
import {
    fadeIn,
    slideToggle,
    slideUp,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const vtsSection = document.querySelectorAll('.vertical-tabs-section');

    vtsSection.forEach((section) => {
        const tabTitles = section.querySelectorAll('.vts-tab-title');
        const allTabContents = section.querySelectorAll('.vts-content-item');
        const dropdown = section.querySelector('.vts-dropdown');
        const tabList = section.querySelector('.vts-tab-list');

        // On load: Set dropdown text to first tab title
        if (dropdown && tabTitles.length > 0) {
            dropdown.querySelector('span').innerHTML = tabTitles[0].innerHTML;
        }

        // Function to handle dropdown toggle
        const handleDropdownToggle = () => {
            if (window.innerWidth < 991 && dropdown) {

                dropdown.addEventListener('click', toggleDropdown);
                document.addEventListener('click', function() {
                    slideUp(tabList);
                });

                tabTitles.forEach(tabTitleEle => {
                    tabTitleEle.addEventListener('click', function() {
                        // Update dropdown text and close dropdown if mobile
                        if (dropdown) {
                            dropdown.querySelector('span').innerHTML = this.innerHTML;
                            dropdown.classList.remove('is-open');
                            slideUp(tabList);
                        }
                    });
                });
            } else {
                dropdown?.removeEventListener('click', toggleDropdown);
                dropdown?.classList.remove('is-open');
                tabList?.removeAttribute('style');
            }
        };

        // Toggle dropdown open/close
        const toggleDropdown = function(event) {
            event.stopPropagation();
            this.classList.toggle('is-open');
            slideToggle(tabList);
        };

        // Initial dropdown toggle setup
        handleDropdownToggle();

        // Resize event listener
        window.addEventListener('resize', handleDropdownToggle);

        // Tab title click event
        tabTitles.forEach(tabTitleEle => {
            tabTitleEle.addEventListener('click', function() {
                const parent = this.parentElement;
                const isOpen = parent.classList.contains('is-active');
                const targetSelector = this.dataset.href;
                const targetContent = section.querySelector('.vts-content-item[data-id="' + targetSelector + '"]');

                if (isOpen) {return;}

                // Remove active class from all tabs
                const allTabItems = parent.parentElement.children;
                Array.from(allTabItems).forEach(item => item.classList.remove('is-active'));

                // Hide all tab content
                allTabContents.forEach(content => {
                    content.style.display = 'none';
                });

                // Show clicked tab content
                parent.classList.add('is-active');
                if (targetContent) {
                    fadeIn(targetContent);
                }

                // Update dropdown text and close dropdown if mobile
                if (dropdown) {
                    dropdown.querySelector('span').innerHTML = this.innerHTML;
                }
            });
        });
    });
});
